import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from '../services/api.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private readonly fetchingIndicatorStatus: Map<number, boolean> = new Map<number, boolean>();
  constructor(private readonly apiService: APIService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const now = Date.now();
    this.startFetchingIndicator(now);
    setTimeout(() => {
      this.stopFetchingIndicator(now);
    }, 100);
    return next.handle(req);
  }

  private startFetchingIndicator(time: number): void {
    this.fetchingIndicatorStatus.set(time, true);
    this.apiService.callingAPI.next(true);
  }

  private stopFetchingIndicator(time: number): void {
    this.fetchingIndicatorStatus.delete(time);
    if (this.fetchingIndicatorStatus.size === 0) {
      setTimeout(() => {
        this.apiService.callingAPI.next(false);
      }, 300);
    }
  }
}
